import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Button } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { canConversationTransferToAgent } from 'components/conversation/utils/conversationTransfer';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { TransferToAgentDropdown } from './components/transferToAgentDropdown/transferToAgentDropdown';
import styles from './conversationTransferToAgent.module.scss';
export const ConversationTransferToAgent = () => {
    const { assignedAgent, metaConversation, conversationAsyncStatus } = useAppSelector((state) => {
        var _a;
        return ({
            assignedAgent: (_a = state.conversation.metaConversation.conversation.assignment) === null || _a === void 0 ? void 0 : _a.agent,
            metaConversation: state.conversation.metaConversation,
            conversationAsyncStatus: state.conversation.asyncStatus.getConversation,
        });
    });
    const canTransferToAgent = canConversationTransferToAgent(metaConversation);
    return (_jsx(_Fragment, { children: canTransferToAgent ? (_jsx(TransferToAgentDropdown, {})) : (_jsx(Button, Object.assign({ variant: "tertiary", disabled: true, isLoading: conversationAsyncStatus === 'loading', className: styles.buttonWithAvater, slotStart: _jsx(Avatar, { user: assignedAgent, size: "24" }) }, { children: assignedAgent ? _jsx(_Fragment, { children: assignedAgent === null || assignedAgent === void 0 ? void 0 : assignedAgent.name }) : _jsx(_Fragment, { children: "Unassigned" }) }))) }));
};
